module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-S-patch-shadow.b3cadc15.png";